import { ActionStatus } from '../../constants/api';
import CreateAction from '../../utils/actions';




export const CREATE_RECORD = CreateAction<any>('CREATE_RECORD');
export const CLEAR_CREATE_RECORD = CreateAction<any>('CLEAR_CREATE_RECORD');


export interface RecordState {
  CREATE_RECORD_STATUS:ActionStatus;
	createError:any;
}